import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { catchError, throwError } from 'rxjs';

import { NotificationStore } from '@/app/core/notifications/notification.store';

/**
 * Aboneliği bitmiş kiracının yazma denemelerini yakalar.
 *
 * Sunucu bu durumda 402 Payment Required döndürüyor — 403'ten AYRI, çünkü
 * sebep yetki değil ödeme. Bu ayrım olmasaydı ekran "yetkiniz yok" derdi ve
 * müşteri kendi hesabında neden işlem yapamadığını anlamazdı.
 *
 * Yakalamazsak her kaydet düğmesi sessizce hiçbir şey yapmaz ya da ham hata
 * basar; müşteri kaydettiğini sanır.
 */
export const subscriptionInterceptor: HttpInterceptorFn = (req, next) => {
  const notify = inject(NotificationStore);
  const router = inject(Router);
  const transloco = inject(TranslocoService);

  return next(req).pipe(
    catchError((err: unknown) => {
      // Zorunlu sözleşme onay bekliyor (AgreementGateMiddleware): yetki ya da ödeme
      // değil — sunucunun mesajı neyin beklendiğini söyler.
      if (err instanceof HttpErrorResponse && err.status === 423 && (err.error?.code === 'agreements_pending' || err.error?.code === 'agreement_module_locked')) {
        notify.show(
          err.error?.message ?? transloco.translate('agrGate.awaitingOwner'),
          transloco.translate('common.actions.ok'),
          { duration: 8000 },
        );
      }

      if (err instanceof HttpErrorResponse && err.status === 402) {
        const kod = err.error?.code as string | undefined;

        notify.show(
          err.error?.message ?? transloco.translate('sub.bannerReadOnly', { days: 0 }),
          transloco.translate('sub.renewNow'),
          { duration: 8000 },
        );

        // Ödeme sayfasına YÖNLENDİRMİYORUZ, yalnız bildiriyoruz: kullanıcı
        // formda yazdıklarını kaybetmemeli. Bandın üstündeki "Şimdi yenile"
        // düğmesi zaten oraya götürüyor ve gitme kararı kullanıcının.
        if (kod === 'subscription_suspended' && router.url.startsWith('/portal/web-builder')) {
          // Tek istisna: web-builder'da düzenlenen içerik zaten kaydedilemez
          // durumda; kullanıcıyı orada tutmak boş yere emek harcatmak olurdu.
          void router.navigate(['/portal/billing']);
        }
      }

      return throwError(() => err);
    }),
  );
};
